// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackReorderOrderParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/order/trackReorderOrder";

const useTrackReorderOrder = (
    parameters: TrackReorderOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.reorderOrder, parameters, options);
};

export default useTrackReorderOrder;
